// @ts-nocheck

import { fetchRequest, initialFetchListParams } from './index';



export const create = async (
washingPrice) =>
{
  const added = await fetchRequest.post(
    '/vehicleWashingTypeToGroupsMap',
    washingPrice
  );
  if (added) return added;
  throw new Error('Не удалось создать прейскурант');
};

export const fetchList = async (
params = initialFetchListParams) =>
{
  const data = await fetchRequest.get('/vehicleWashingTypeToGroupsMap', {
    ...initialFetchListParams,
    ...params
  });
  if (data) return data;
  throw new Error('Не удалось получить список прейскуранта');
};

export const update = async (
washingPrice) =>
{
  const updated = await fetchRequest.put(
    '/vehicleWashingTypeToGroupsMap',
    washingPrice
  );
  if (updated) return updated;
  throw new Error('Не удалось обновить прейскурант');
};

export const fetchOne = async (
id) =>
{
  let washingPrice = await fetchRequest.get(
    `/vehicleWashingTypeToGroupsMap/${id}`
  );
  if (washingPrice) return washingPrice;
  throw new Error('Не удалось загрузить прейскурант');
};

export const deleteMap = async (
id) =>
{
  const deleted = await fetchRequest.delete(
    `/vehicleWashingTypeToGroupsMap/${id}`
  );
  if (deleted) return deleted;
  throw new Error('Не удалось удалить прейскурант');
};

export default {
  fetchList,
  fetchOne,
  deleteMap,
  create,
  update
};
